<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12">
        <h1 class="page-title">Sync Dashboard</h1>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12">
        <div class="header-right-box">
            <span class="last-updated-text" *ngIf="lastUpdated">Last updated: {{ lastUpdated.format('MM/DD/YYYY hh:mm A') }}</span>
            <button nz-button nzType="primary" [nzLoading]="isHealthLoaded" (click)="refresh()">Refresh sync data</button>
        </div>
    </div>
</div>

<!-- Connector health cards -- the primary visual anchor of this page (UI-SPEC): exactly 3, in order
     Shopify / QBO / AfterShip, no more, no fewer. Avalara was dropped (QA bug #3) -- it is not a
     BadeLoft connector, so a hard-coded "Not configured" card only misled ops about tax. -->
<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 16, lg: 16 }" class="sync-health-row">
    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="8" *ngFor="let card of healthCards">
        <nz-card>
            <div class="d-flex justify-content-space-between">
                <div class="sync-card-title">{{ card.connector }}</div>
            </div>
            <div class="status-text" [ngClass]="getHealthPillClass(card.status)">
                {{ getHealthPillLabel(card.status) }}
            </div>
            <div class="sync-card-body">
                <ng-container *ngIf="card.lastSyncUtc; else noSyncData">
                    Last sync: {{ card.lastSyncUtc | date: 'MM/dd/yyyy hh:mm a' : 'UTC' }}
                </ng-container>
                <ng-template #noSyncData>
                    No sync activity recorded yet for {{ card.connector }}.
                </ng-template>
            </div>
        </nz-card>
    </div>
    <div class="gutter-row" nz-col nzSpan="24" *ngIf="!isHealthLoaded && healthCards.length === 0">
        <nz-card>Couldn't load sync activity. Check your connection and try refreshing the page.</nz-card>
    </div>
</div>

<!-- Sync activity filter bar + table -->
<div class="sync-activity-heading">Sync Activity</div>
<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="sync-filter-row">
    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="6" nzLg="5">
        <label class="modal-label">Connector</label>
        <nz-select style="width: 100%;" [(ngModel)]="filterConnector" (ngModelChange)="onConnectorFilterChange()">
            <nz-option nzValue="All" nzLabel="All"></nz-option>
            <nz-option nzValue="Shopify" nzLabel="Shopify"></nz-option>
            <nz-option nzValue="QBO" nzLabel="QBO"></nz-option>
            <nz-option nzValue="AfterShip" nzLabel="AfterShip"></nz-option>
        </nz-select>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="6" nzLg="5">
        <label class="modal-label">Status</label>
        <nz-select style="width: 100%;" [(ngModel)]="filterStatus" (ngModelChange)="onStatusFilterChange()">
            <nz-option nzValue="All" nzLabel="All"></nz-option>
            <nz-option nzValue="Pending" nzLabel="Pending"></nz-option>
            <nz-option nzValue="Invoiced" nzLabel="Invoiced"></nz-option>
            <nz-option nzValue="Paid" nzLabel="Paid"></nz-option>
            <nz-option nzValue="Refunded" nzLabel="Refunded"></nz-option>
            <nz-option nzValue="Voided" nzLabel="Voided"></nz-option>
            <nz-option nzValue="Error" nzLabel="Error"></nz-option>
            <nz-option nzValue="Synced" nzLabel="Synced"></nz-option>
            <nz-option nzValue="Skipped" nzLabel="Skipped"></nz-option>
            <nz-option nzValue="NotSynced" nzLabel="Not Synced"></nz-option>
        </nz-select>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="6" nzLg="5">
        <label class="modal-label">Date Range</label>
        <div class="date-filter-div">
            <input type="text" class="form-control date-picker input" [readonly]="true" ngxDaterangepickerMd
                [(ngModel)]="selected" (ngModelChange)="onDateChange($event)" placeholder="Filter By Date"
                [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [opens]="'left'"
                [showClearButton]="false">
        </div>
    </div>
</div>

<div class="table-height dashboard" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <!-- nzTableLayout="fixed" + nzWidth are what let the Summary cell's nzEllipsis actually clamp:
         ng-zorro can only ellipsize under table-layout: fixed. Without them the cell's nowrap
         stretches the column to fit the whole payload and the table runs off the screen.
         Deliberately NOT using nzScroll here: an x-only nzScroll wraps thead+tbody in ng-zorro's own
         .ant-table-content overflow-x container, which becomes the sticky containing block and kills
         this page's sticky black header. Instead, GLOBAL styles.css pins a min-width (1340px, the sum
         of the six nzWidth values below) on the table via the page-unique .sync-activity-table class
         so table-layout: fixed can't scale them down to fit -- the overflow lands on the outer
         .table-height (overflow: scroll) and gives a real horizontal scrollbar while keeping the sticky
         header intact. This rule CANNOT live in this component's CSS: ng-zorro renders the inner
         <table> from its own NzTableInnerDefaultComponent template, so it carries no _ngcontent
         attribute and an emulated-encapsulation selector here would never match it. -->
    <nz-table class="main-table-header sync-activity-table" [nzData]="lst_Activity" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Activity.length > 0 || isActivityLoaded}">
        <thead class="tablehead">
            <tr class="tableheader">
                <th [nzAlign]="'left'" nzWidth="180px">Timestamp</th>
                <th [nzAlign]="'left'" nzWidth="120px">Connector</th>
                <th [nzAlign]="'left'" nzWidth="200px">Order Ref</th>
                <th [nzAlign]="'left'" nzWidth="110px">Status</th>
                <th [nzAlign]="'left'" nzWidth="600px">Summary</th>
                <th [nzAlign]="'left'" nzWidth="130px"></th>
            </tr>
        </thead>
        <tbody *ngIf="!isActivityLoaded">
            <ng-container *ngFor="let data of lst_Activity;let i = index;let even=even;">
                <tr [ngClass]="{'is-even-row' : even}">
                    <td [nzAlign]="'left'">{{ data.timestamp | date: 'MM/dd/yyyy hh:mm a' : 'UTC' }}</td>
                    <td [nzAlign]="'left'">{{ data.connector }}</td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.orderRef?.length > 14 ? data.orderRef : ''">{{ data.orderRef ? data.orderRef : '-' }}</td>
                    <td [nzAlign]="'left'">
                        <span class="status-text" [ngClass]="getStatusPillClass(data.status)">
                            <span nz-icon nzType="close-circle" class="close-icon" *ngIf="data.status === 'Error'"></span>{{ data.status }}</span>
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.summary?.length > 40 ? data.summary : ''">{{ data.summary }}</td>
                    <td [nzAlign]="'left'">
                        <a (click)="toggleExpand(i)">
                            <span nz-icon [nzType]="expandSet.has(i) ? 'down' : 'right'"></span>
                            View details
                        </a>
                    </td>
                </tr>
                <tr *ngIf="expandSet.has(i)" [nzExpand]="expandSet.has(i)">
                    <td [nzAlign]="'left'" colspan="6">
                        <div class="sync-error-detail">
                            <div class="sync-error-detail-heading">Error detail</div>
                            <div><span class="fw-bold">Timestamp:</span> {{ data.timestamp | date: 'MM/dd/yyyy hh:mm a' : 'UTC' }}</div>
                            <div><span class="fw-bold">Connector:</span> {{ data.connector }}</div>
                            <div><span class="fw-bold">Order Ref:</span> {{ data.orderRef ? data.orderRef : '-' }}</div>
                            <div><span class="fw-bold">Status:</span> {{ data.status }}</div>
                            <!-- Payload is fetched on expand (see loadDetail) rather than shipped with every
                                 row, so this block has three states. nz-spin/.text-danger are the global
                                 loading + error affordances used elsewhere; no new CSS. -->
                            <ng-container *ngIf="data.detailLoading">
                                <div class="fw-bold">Payload</div>
                                <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
                            </ng-container>
                            <ng-container *ngIf="!data.detailLoading && data.detailError">
                                <div class="fw-bold">Payload</div>
                                <div class="text-danger">Could not load the payload. Collapse and reopen this row to retry.</div>
                            </ng-container>
                            <ng-container *ngIf="!data.detailLoading && !data.detailError && data.errorDetail">
                                <div class="fw-bold">Payload</div>
                                <pre class="sync-error-detail-payload">{{ data.errorDetail }}</pre>
                            </ng-container>
                        </div>
                    </td>
                </tr>
            </ng-container>
            <tr *ngIf="lst_Activity.length === 0">
                <td colspan="6">
                    <div class="sync-empty-state">
                        <div class="sync-empty-state-heading">No sync activity in this range</div>
                        <div>Try widening the date range or clearing a filter.</div>
                    </div>
                </td>
            </tr>
        </tbody>
        <ng-container *ngIf="isActivityLoaded">
            <tbody>
                <tr *ngFor="let i of [].constructor(100)">
                    <ng-container *ngFor="let i of [].constructor(6)">
                        <td [nzAlign]="'left'" class="loading">
                            <div class="bar"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
    </nz-table>
</div>
